import { useState, useMemo, useEffect } from 'react';
import { apiUrl } from '../../config/supabase';

// 🤖 حالة كل عميل مع المساعد الذكي (مربوط تليجرام؟ + الأيام المتبقية في الدعم المجاني)
const useBotAccess = () => {
  const [acc, setAcc] = useState({});
  const [months, setMonths] = useState(12);
  useEffect(() => {
    let token = ''; try { token = localStorage.getItem('emp_token') || ''; } catch {}
    fetch(apiUrl('/api/admin/bot/customer-access'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) })
      .then(r => r.json()).then(j => { if (j && j.ok) { setAcc(j.rows || {}); if (j.free_access_months) setMonths(j.free_access_months); } }).catch(() => {});
  }, []);
  return { acc, months };
};
const botBadge = (a) => {
  if (!a) return { txt: '…', bg: '#f1f5f9', fg: '#94a3b8' };
  if (a.state === 'open') return { txt: `${a.days_left} يوم${a.source === 'paid' ? ' (مدفوع)' : ''}`, bg: a.days_left <= 30 ? '#fef3c7' : '#dcfce7', fg: a.days_left <= 30 ? '#b45309' : '#15803d' };
  if (a.state === 'expired') return { txt: 'انتهت المجانية', bg: '#fee2e2', fg: '#b91c1c' };
  return { txt: 'مش مشترك', bg: '#f1f5f9', fg: '#64748b' };
};

// ════════════════════════════════════════════════════════════
// CustomersManager — إدارة العملاء الاحترافية (Data Grid + بحث/فلاتر
// + بروفايل جانبي + إضافة/تعديل/تغيير باسورد). كل الكتابة عبر السيرفر.
//   props:
//     customers, enrollments, courses, lang, isRTL
//     onCreate(payload) -> {ok}|{error}
//     onUpdate(id, fields) -> {ok}|{error}
//     onSetPassword(id, newPassword) -> {ok}|{error}
//     onToggle(customer)   (بيعمل التأكيد/التوست جوه App)
//     onDelete(id)         (بيعمل التأكيد/التوست جوه App)
//     showToast(msg, type)
// ════════════════════════════════════════════════════════════

const P1 = '#667eea', P2 = '#764ba2';
const G1 = `linear-gradient(135deg,${P1} 0%,${P2} 100%)`;

const genPassword = () => {
  const ch = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789@#%';
  let p = '';
  for (let i = 0; i < 10; i++) p += ch[Math.floor(Math.random() * ch.length)];
  return p;
};

const fmtDate = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('ar-EG', { year: 'numeric', month: '2-digit', day: '2-digit' }); }
  catch { return '—'; }
};

export default function CustomersManager({
  customers = [], enrollments = [], courses = [], lang = 'ar', isRTL = true,
  onCreate, onUpdate, onSetPassword, onToggle, onDelete, showToast,
}) {
  const [q, setQ]               = useState('');
  const [fStatus, setFStatus]   = useState('');
  const [fSub, setFSub]         = useState('');
  const [sort, setSort]         = useState('new');
  const [openId, setOpenId]     = useState(null);      // العميل المفتوح في البروفايل
  const { acc: botAcc, months: freeMonths } = useBotAccess();
  const [fBot, setFBot]         = useState('');         // فلتر: مربوط / مش مربوط / منتهي
  const [modal, setModal]       = useState(null);      // 'add' | 'edit' | 'pass'
  const [busy, setBusy]         = useState(false);
  const [form, setForm]         = useState({});

  const courseName = (id) => {
    const c = courses.find(x => x.id === id);
    if (!c) return 'كورس';
    return lang === 'ar' ? (c.name_ar || c.name_en || 'كورس') : (c.name_en || c.name_ar || 'كورس');
  };
  const subsCount = (cid) =>
    enrollments.filter(e => e.customer_id === cid && e.status === 'active').length;
  const custCourses = (cid) =>
    enrollments.filter(e => e.customer_id === cid && e.status === 'active');

  // ── الفلترة + الترتيب ──
  const list = useMemo(() => {
    const term = q.trim().toLowerCase();
    let out = customers.filter(c => {
      const hay = [c.name, c.username, c.email, c.phone].filter(Boolean).join(' ').toLowerCase();
      const hit = !term || hay.includes(term);
      const sOk = !fStatus || (fStatus === 'on' ? c.is_active !== false : c.is_active === false);
      const n = subsCount(c.id);
      const bOk = !fSub || (fSub === 'has' ? n > 0 : n === 0);
      const a = botAcc[c.id];
      const tOk = !fBot || (fBot === 'linked' ? !!a?.telegram_linked : fBot === 'unlinked' ? !a?.telegram_linked : fBot === 'open' ? a?.state === 'open' : fBot === 'soon' ? (a?.state === 'open' && a.days_left <= 30) : fBot === 'expired' ? a?.state === 'expired' : true);
      return hit && sOk && bOk && tOk;
    });
    out.sort((a, b) => {
      if (sort === 'new')  return new Date(b.created_at || 0) - new Date(a.created_at || 0);
      if (sort === 'old')  return new Date(a.created_at || 0) - new Date(b.created_at || 0);
      if (sort === 'name') return String(a.name || '').localeCompare(String(b.name || ''), 'ar');
      if (sort === 'subs') return subsCount(b.id) - subsCount(a.id);
      return 0;
    });
    return out;
  }, [customers, enrollments, q, fStatus, fSub, fBot, botAcc, sort]); // eslint-disable-line

  const opened = customers.find(c => c.id === openId) || null;

  // ── فتح المودالات ──
  const openAdd = () => { setForm({ name: '', username: '', email: '', phone: '', password: '' }); setModal('add'); };
  const openEdit = (c) => { setForm({ name: c.name || '', username: c.username || '', email: c.email || '', phone: c.phone || '' }); setModal('edit'); };
  const openPass = () => { setForm({ password: '', confirm: '' }); setModal('pass'); };
  const closeModal = () => { if (!busy) setModal(null); };

  // ── حفظ ──
  const submitAdd = async () => {
    if (!form.name?.trim())          return showToast('اكتب اسم العميل', 'error');
    if ((form.username || '').trim().length < 3) return showToast('اسم المستخدم 3 أحرف على الأقل', 'error');
    if (!form.email?.trim())         return showToast('البريد الإلكتروني مطلوب', 'error');
    if ((form.password || '').length < 4) return showToast('كلمة المرور قصيرة (4 على الأقل)', 'error');
    setBusy(true);
    const r = await onCreate({ name: form.name, username: form.username, email: form.email, phone: form.phone, password: form.password });
    setBusy(false);
    if (r?.error) return showToast('❌ ' + r.error, 'error');
    showToast('✅ تم إضافة العميل', 'success');
    setModal(null);
  };
  const submitEdit = async () => {
    if (!form.name?.trim())          return showToast('اكتب اسم العميل', 'error');
    if ((form.username || '').trim().length < 3) return showToast('اسم المستخدم 3 أحرف على الأقل', 'error');
    if (!form.email?.trim())         return showToast('البريد الإلكتروني مطلوب', 'error');
    setBusy(true);
    const r = await onUpdate(openId, { name: form.name, username: form.username, email: form.email, phone: form.phone });
    setBusy(false);
    if (r?.error) return showToast('❌ ' + r.error, 'error');
    showToast('✅ تم تعديل البيانات', 'success');
    setModal(null);
  };
  const submitPass = async () => {
    if ((form.password || '').length < 4) return showToast('كلمة المرور قصيرة (4 على الأقل)', 'error');
    if (form.password !== form.confirm)   return showToast('الباسوردين مش متطابقين', 'error');
    setBusy(true);
    const r = await onSetPassword(openId, form.password);
    setBusy(false);
    if (r?.error) return showToast('❌ ' + r.error, 'error');
    showToast('✅ تم تعيين باسورد جديد', 'success');
    setModal(null);
  };

  // ════════ styles ════════
  const S = {
    head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 },
    title: { fontSize: 17, fontWeight: 800, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 8, margin: 0 },
    add: { background: G1, color: '#fff', border: 'none', padding: '11px 20px', borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: 'pointer', boxShadow: '0 6px 18px rgba(102,126,234,.35)' },
    bar: { background: '#fff', borderRadius: 14, padding: 14, marginBottom: 14, boxShadow: '0 2px 12px rgba(0,0,0,.04)', display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' },
    search: { flex: 1, minWidth: 220, border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 14px', fontSize: 14, outline: 'none', fontFamily: 'inherit' },
    sel: { border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 12px', fontSize: 13, background: '#fff', cursor: 'pointer', outline: 'none', fontWeight: 600, color: '#1e293b', fontFamily: 'inherit' },
    count: { fontSize: 12.5, color: '#64748b', fontWeight: 700, padding: '0 4px' },
    grid: { background: '#fff', borderRadius: 14, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,.04)' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { background: '#f8fafc', padding: '13px 14px', fontSize: 12.5, fontWeight: 700, color: '#64748b', textAlign: isRTL ? 'right' : 'left', borderBottom: '2px solid #e2e8f0', whiteSpace: 'nowrap' },
    td: { padding: '12px 14px', borderBottom: '1px solid #f1f5f9', fontSize: 13.5, verticalAlign: 'middle' },
    un: { fontFamily: 'monospace', background: '#f1f5f9', padding: '3px 8px', borderRadius: 6, fontSize: 12.5, color: P2, fontWeight: 700 },
    mini: (bg, c) => ({ background: bg, color: c, border: 'none', borderRadius: 8, padding: '6px 8px', fontSize: 12, cursor: 'pointer', fontWeight: 700 }),
  };
  const badge = (on) => ({ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, fontSize: 11.5, fontWeight: 700, background: on ? '#d1fae5' : '#fee2e2', color: on ? '#047857' : '#b91c1c' });
  const subBadge = (n) => ({ background: n ? '#ede9fe' : '#f1f5f9', color: n ? P2 : '#94a3b8', padding: '3px 10px', borderRadius: 20, fontSize: 11.5, fontWeight: 700 });

  return (
    <div style={{ marginBottom: 28 }}>
      <div style={S.head}>
        <h3 style={S.title}>👥 العملاء</h3>
        <button style={S.add} onClick={openAdd}>＋ إضافة عميل جديد</button>
      </div>

      {/* Toolbar */}
      <div style={S.bar}>
        <input style={S.search} placeholder="ابحث بالاسم، اليوزرنيم، الإيميل، أو التليفون…" value={q} onChange={e => setQ(e.target.value)} />
        <select style={S.sel} value={fStatus} onChange={e => setFStatus(e.target.value)}>
          <option value="">كل الحالات</option>
          <option value="on">نشط فقط</option>
          <option value="off">موقوف فقط</option>
        </select>
        <select style={S.sel} value={fSub} onChange={e => setFSub(e.target.value)}>
          <option value="">كل الاشتراكات</option>
          <option value="has">مشترك في كورس+</option>
          <option value="none">بدون اشتراك</option>
        </select>
        <select style={S.sel} value={fBot} onChange={e => setFBot(e.target.value)}>
          <option value="">🤖 كل حالات المساعد</option>
          <option value="linked">📱 مربوط تليجرام</option>
          <option value="unlinked">غير مربوط تليجرام</option>
          <option value="open">دعم مجاني ساري</option>
          <option value="soon">ينتهي خلال 30 يوم</option>
          <option value="expired">انتهت المجانية</option>
        </select>
        <select style={S.sel} value={sort} onChange={e => setSort(e.target.value)}>
          <option value="new">الأحدث تسجيلًا</option>
          <option value="old">الأقدم تسجيلًا</option>
          <option value="name">الاسم (أ-ي)</option>
          <option value="subs">الأكثر اشتراكًا</option>
        </select>
        <span style={S.count}>{list.length} من {customers.length} عميل</span>
      </div>

      {/* Grid */}
      <div style={S.grid}>
        <div style={{ overflowX: 'auto' }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={{ ...S.th, width: 40 }}>#</th>
                <th style={S.th}>الاسم</th>
                <th style={S.th}>اليوزرنيم</th>
                <th style={S.th}>الإيميل</th>
                <th style={S.th}>التليفون</th>
                <th style={S.th}>الاشتراكات</th>
                <th style={S.th}>الحالة</th>
                <th style={S.th}>🤖 المساعد</th>
                <th style={S.th}>📱 تليجرام</th>
                <th style={S.th}>تاريخ التسجيل</th>
                <th style={{ ...S.th, width: 150 }}>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {list.map((c, i) => {
                const on = c.is_active !== false;
                const n = subsCount(c.id);
                return (
                  <tr key={c.id} style={{ cursor: 'pointer', transition: '.15s' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#faf5ff'}
                      onMouseLeave={e => e.currentTarget.style.background = ''}
                      onClick={(e) => { if (!e.target.closest('button')) setOpenId(c.id); }}>
                    <td style={{ ...S.td, color: '#94a3b8', fontWeight: 700 }}>{i + 1}</td>
                    <td style={{ ...S.td, fontWeight: 700, color: '#1e293b' }}>{c.name}</td>
                    <td style={S.td}><span style={S.un}>{c.username || '—'}</span></td>
                    <td style={{ ...S.td, color: P1, fontSize: 12.5 }}>{c.email}</td>
                    <td style={{ ...S.td, fontFamily: 'monospace', fontSize: 12.5, color: '#64748b' }}>{c.phone || '—'}</td>
                    <td style={S.td}><span style={subBadge(n)}>{n} كورس</span></td>
                    <td style={S.td}><span style={badge(on)}><span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />{on ? 'نشط' : 'موقوف'}</span></td>
                    <td style={S.td}>{(() => { const b = botBadge(botAcc[c.id]); return <span title={botAcc[c.id]?.access_until ? `حتى ${fmtDate(botAcc[c.id].access_until)}` : ''} style={{ background: b.bg, color: b.fg, padding: '3px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' }}>{b.txt}</span>; })()}</td>
                    <td style={S.td}>{botAcc[c.id]?.telegram_linked
                      ? <span title={botAcc[c.id].telegram_username ? `@${botAcc[c.id].telegram_username}` : botAcc[c.id].telegram_name || ''} style={{ background: '#dbeafe', color: '#1d4ed8', padding: '3px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' }}>✓ مربوط{botAcc[c.id].telegram_username ? ` @${botAcc[c.id].telegram_username}` : ''}</span>
                      : <span style={{ background: '#f1f5f9', color: '#94a3b8', padding: '3px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 700 }}>غير مربوط</span>}</td>
                    <td style={{ ...S.td, color: '#64748b', fontSize: 12.5 }}>{fmtDate(c.created_at)}</td>
                    <td style={S.td}>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <button title="عرض" style={S.mini('#ede9fe', P2)} onClick={() => setOpenId(c.id)}>👁️</button>
                        <button title="تغيير باسورد" style={S.mini('#fef3c7', '#b45309')} onClick={() => { setOpenId(c.id); openPass(); }}>🔑</button>
                        <button title={on ? 'إيقاف' : 'تفعيل'} style={S.mini('#fff7ed', '#c2410c')} onClick={() => onToggle(c)}>{on ? '⏸️' : '▶️'}</button>
                        <button title="حذف" style={S.mini('#fee2e2', '#b91c1c')} onClick={() => onDelete(c.id)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {!list.length && (
                <tr><td colSpan="11" style={{ padding: 36, textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>لا يوجد عملاء مطابقين</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Drawer (بروفايل) */}
      {opened && (
        <>
          <div onClick={() => setOpenId(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.5)', zIndex: 1000, backdropFilter: 'blur(2px)' }} />
          <div style={{ position: 'fixed', top: 0, [isRTL ? 'left' : 'right']: 0, height: '100vh', width: 420, maxWidth: '92vw', background: '#fff', zIndex: 1001, overflowY: 'auto', boxShadow: '0 0 40px rgba(0,0,0,.25)' }}>
            <div style={{ background: G1, color: '#fff', padding: '26px 22px', position: 'relative' }}>
              <button onClick={() => setOpenId(null)} style={{ position: 'absolute', top: 16, [isRTL ? 'left' : 'right']: 16, background: 'rgba(255,255,255,.2)', border: 'none', color: '#fff', width: 32, height: 32, borderRadius: 9, fontSize: 16, cursor: 'pointer' }}>✕</button>
              <div style={{ width: 70, height: 70, borderRadius: 18, background: 'rgba(255,255,255,.25)', display: 'grid', placeItems: 'center', fontSize: 28, fontWeight: 800, marginBottom: 12 }}>{(opened.name || '?').charAt(0).toUpperCase()}</div>
              <div style={{ fontSize: 21, fontWeight: 800, marginBottom: 6 }}>{opened.name}</div>
              <span style={{ fontFamily: 'monospace', background: 'rgba(255,255,255,.2)', padding: '4px 11px', borderRadius: 8, fontSize: 12.5, fontWeight: 700 }}>@{opened.username || '—'}</span>
            </div>
            <div style={{ padding: '20px 22px' }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#64748b', letterSpacing: .5, marginBottom: 8 }}>📋 البيانات الأساسية</div>
              {[['الإيميل', opened.email], ['التليفون', opened.phone || '—'], ['تاريخ التسجيل', fmtDate(opened.created_at)]].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13.5 }}>
                  <span style={{ color: '#64748b', fontWeight: 600 }}>{k}</span>
                  <span style={{ fontWeight: 700, color: '#1e293b', wordBreak: 'break-all', textAlign: isRTL ? 'left' : 'right' }}>{v}</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13.5 }}>
                <span style={{ color: '#64748b', fontWeight: 600 }}>الحالة</span>
                <span style={badge(opened.is_active !== false)}><span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />{opened.is_active !== false ? 'نشط' : 'موقوف'}</span>
              </div>

              {(() => { const a = botAcc[opened.id]; const b = botBadge(a); return (
                <div style={{ margin: '14px 0 0', padding: 12, borderRadius: 12, background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: '#64748b', letterSpacing: .5, marginBottom: 8 }}>🤖 المساعد الذكي</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12.5 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#64748b' }}>الدعم المجاني</span><span style={{ background: b.bg, color: b.fg, padding: '2px 9px', borderRadius: 999, fontWeight: 700 }}>{b.txt}</span></div>
                    {a?.access_until && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#64748b' }}>ينتهي في</span><span style={{ fontWeight: 700 }}>{fmtDate(a.access_until)}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#64748b' }}>تليجرام</span><span style={{ fontWeight: 700, color: a?.telegram_linked ? '#1d4ed8' : '#94a3b8' }}>{a?.telegram_linked ? `✓ مربوط ${a.telegram_username ? '@' + a.telegram_username : (a.telegram_name || '')}` : 'غير مربوط'}</span></div>
                    {a?.linked_at && <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#64748b' }}>تاريخ الربط</span><span>{fmtDate(a.linked_at)}</span></div>}
                    <div style={{ color: '#94a3b8', fontSize: 11 }}>المشترك بياخد {freeMonths} شهر دعم مجاني من تاريخ اشتراكه في أول كورس.</div>
                  </div>
                </div>
              ); })()}
              <div style={{ fontSize: 12, fontWeight: 800, color: '#64748b', letterSpacing: .5, margin: '18px 0 8px' }}>🎓 الاشتراكات ({custCourses(opened.id).length})</div>
              {custCourses(opened.id).length ? custCourses(opened.id).map((e, idx) => (
                <div key={idx} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 13px', marginBottom: 7, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13.5 }}>
                  <span style={{ fontWeight: 700 }}>{courseName(e.course_id)}</span>
                  <span style={{ fontSize: 11.5, color: '#94a3b8' }}>{fmtDate(e.paid_at || e.created_at)}</span>
                </div>
              )) : <div style={{ color: '#94a3b8', fontSize: 13.5, padding: '6px 0' }}>لا توجد اشتراكات بعد</div>}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 9, marginTop: 18 }}>
                <button style={{ background: '#ede9fe', color: P2, border: 'none', borderRadius: 11, padding: 12, fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }} onClick={() => openEdit(opened)}>✏️ تعديل البيانات</button>
                <button style={{ background: '#fef3c7', color: '#b45309', border: 'none', borderRadius: 11, padding: 12, fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }} onClick={openPass}>🔑 تغيير الباسورد</button>
                <button style={{ background: '#fff7ed', color: '#c2410c', border: 'none', borderRadius: 11, padding: 12, fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }} onClick={() => onToggle(opened)}>{opened.is_active !== false ? '⏸️ إيقاف الحساب' : '▶️ تفعيل الحساب'}</button>
                <button style={{ background: '#fee2e2', color: '#b91c1c', border: 'none', borderRadius: 11, padding: 12, fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }} onClick={() => { onDelete(opened.id); setOpenId(null); }}>🗑️ حذف</button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modals */}
      {modal && (
        <div onClick={closeModal} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 18, backdropFilter: 'blur(3px)' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 18, width: '100%', maxWidth: 430, overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,.3)' }}>
            <div style={{ background: G1, color: '#fff', padding: '20px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ fontSize: 18, fontWeight: 800, margin: 0 }}>
                {modal === 'add' ? '＋ إضافة عميل جديد' : modal === 'edit' ? '✏️ تعديل بيانات العميل' : '🔑 تعيين باسورد جديد'}
              </h3>
              <button onClick={closeModal} style={{ background: 'rgba(255,255,255,.2)', border: 'none', color: '#fff', width: 30, height: 30, borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>✕</button>
            </div>
            <div style={{ padding: 22 }}>
              {modal === 'add' && (
                <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '11px 13px', fontSize: 12.5, color: '#92400e', marginBottom: 16, lineHeight: 1.6 }}>
                  ℹ️ بتضيف العميل بنفسك — زي ما بيسجّل من المتصفح بالظبط. الباسورد بيتشفّر تلقائيًا.
                </div>
              )}
              {modal === 'pass' && (
                <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '11px 13px', fontSize: 12.5, color: '#92400e', marginBottom: 16, lineHeight: 1.6 }}>
                  ⚠️ الباسورد القديم مشفّر ومينفعش يتعرض — تقدر تعيّن جديد بس.
                </div>
              )}

              {(modal === 'add' || modal === 'edit') && (
                <>
                  <Field label="الاسم الكامل" req value={form.name} onChange={v => setForm(f => ({ ...f, name: v }))} placeholder="مثال: أحمد محمد" />
                  <Field label="اليوزرنيم" req value={form.username} onChange={v => setForm(f => ({ ...f, username: v }))} placeholder="مثال: ahmed_m" mono />
                  <Field label="الإيميل" req value={form.email} onChange={v => setForm(f => ({ ...f, email: v }))} placeholder="example@gmail.com" mono />
                  <Field label="التليفون" value={form.phone} onChange={v => setForm(f => ({ ...f, phone: v }))} placeholder="010xxxxxxxx" mono />
                </>
              )}
              {modal === 'add' && (
                <PassField label="الباسورد" value={form.password} onChange={v => setForm(f => ({ ...f, password: v }))} onGen={() => setForm(f => ({ ...f, password: genPassword() }))} />
              )}
              {modal === 'pass' && (
                <>
                  <PassField label="الباسورد الجديد" value={form.password} onChange={v => setForm(f => ({ ...f, password: v }))} onGen={() => setForm(f => ({ ...f, password: genPassword(), confirm: f.confirm }))} />
                  <Field label="تأكيد الباسورد" value={form.confirm} onChange={v => setForm(f => ({ ...f, confirm: v }))} placeholder="اكتب الباسورد تاني" mono />
                </>
              )}

              <button disabled={busy} onClick={modal === 'add' ? submitAdd : modal === 'edit' ? submitEdit : submitPass}
                style={{ width: '100%', background: G1, color: '#fff', border: 'none', borderRadius: 12, padding: 13, fontSize: 15, fontWeight: 800, cursor: busy ? 'wait' : 'pointer', marginTop: 8, opacity: busy ? .7 : 1, boxShadow: '0 6px 18px rgba(102,126,234,.35)' }}>
                {busy ? '... جاري الحفظ' : modal === 'add' ? 'حفظ العميل' : modal === 'edit' ? 'حفظ التعديلات' : 'حفظ الباسورد الجديد'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── حقول مساعدة ──
function Field({ label, value, onChange, placeholder, req, mono }) {
  return (
    <div style={{ marginBottom: 15 }}>
      <label style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>
        {label} {req && <span style={{ color: '#ef4444' }}>*</span>}
      </label>
      <input value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ width: '100%', border: '1.5px solid #e2e8f0', borderRadius: 11, padding: '11px 13px', fontSize: 14, outline: 'none', fontFamily: mono ? 'monospace' : 'inherit', boxSizing: 'border-box' }} />
    </div>
  );
}
function PassField({ label, value, onChange, onGen }) {
  return (
    <div style={{ marginBottom: 15 }}>
      <label style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>
        {label} <span style={{ color: '#ef4444' }}>*</span>
      </label>
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={value || ''} onChange={e => onChange(e.target.value)} placeholder="اكتب أو ولّد"
          style={{ flex: 1, border: '1.5px solid #e2e8f0', borderRadius: 11, padding: '11px 13px', fontSize: 14, outline: 'none', fontFamily: 'monospace', boxSizing: 'border-box' }} />
        <button onClick={onGen} style={{ background: '#ede9fe', color: '#764ba2', border: 'none', borderRadius: 11, padding: '0 15px', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>🎲 توليد</button>
      </div>
    </div>
  );
}
